import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/nb';
import 'dayjs/locale/en';
import i18next from 'i18next';
function setLanguage(lng) {
  dayjs.locale(lng === 'en' ? 'en' : 'nb');
}
export default function initializeDayjs(locale) {
  dayjs.extend(localizedFormat);
  dayjs.extend(utc);
  dayjs.extend(customParseFormat);
  i18next.on('languageChanged', setLanguage);
  setLanguage(locale);
}